import { IconChevronDown } from "@tabler/icons-react";
import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export const NativeSelect = forwardRef<
  HTMLSelectElement,
  SelectHTMLAttributes<HTMLSelectElement>
>(function NativeSelect({ className, children, ...props }, ref) {
  return (
    <div className="relative w-full">
      <select
        ref={ref}
        className={cn(
          "w-full appearance-none rounded-xl border border-ds-slate-300 bg-white py-3 pl-4 pr-11 font-dm-sans text-ui-body text-primary-black focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ds-slate-500",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <IconChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-4 top-1/2 size-4 -translate-y-1/2 text-ds-slate-500"
      />
    </div>
  );
});
